import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class BadgeService {


  public notificationState = new BehaviorSubject(0)
  public searchState: BehaviorSubject<string> = new BehaviorSubject('')

  constructor() { }

  public emitNotification(count: number) {
    this.notificationState.next(count)
  }

  public emitSearchState(count: string) {
    this.searchState.next(count)
  }

}
